import React, { Fragment, useContext, useRef, useState } from 'react'
import { Alert } from 'react-bootstrap'

import { UserContext } from "../../Contexts/UserContext/UserContext.js"
import { Row } from "../../components/Row.js"
import { Spaces } from "../../components/Spaces.js"
import { TextDisplay } from "../../components/TextDisplay/TextDisplay.js"
import { Tableau } from "../../components/Tableau.js"
import useLog from '../../hooks/useLog.js'
import useTxSender from '../../hooks/useTxSender.js'
import { shortTxHash, ShortTxHash } from '../../components/ShortTxHash.js'
import SuccessTxSender from '../../components/SuccessTxSender.js'
import { default_func_jsx_fail } from '../../helpers/helpers.js'
import InputTokenAddress from '../../components/InputTokenAddress.js'
import { confirmPopup } from '../../components/confirmPopup.js'
import Bold from '../../components/Bold.js'



/**
 *  props:
 * 
*/
export default function Slide_BlacklistAddress(props) {
	const userContext = useContext(UserContext)
	const log = useLog("Slide_BlacklistAddress: ")

	// --- VARS ---

	const coinprops = userContext.get_selected_coin_props()
	const tokenID = coinprops.tokenid
	const tokenName = coinprops.name

	const tokenActionID = tokenID + "_blacklist" // or mint_delphe ?
	const mess_default = "" //"Un récapitulatif des "+tokenName+" à burn va s'afficher ici"

	// state & refs
	const [addressToBlacklist, set_addressToBlacklist] = useState("")
	const [localError_jsx, set_localError_jsx] = useState(null)
	const ref_messageEndRef = useRef(null) // for autoscroll

	const array_bool_user_inputs = [
		Boolean(addressToBlacklist && addressToBlacklist.length > 0),
	]

	const token_balance = userContext.tokens_balance[tokenID]
	const bool_context_has_loaded = (token_balance != null) // && (context.bsvprice !=null)


	// --- FUNCTIONS ---

	async function func_empty_fields() {
		set_addressToBlacklist("")
		set_localError_jsx("")
	}

	// --- DISPLAY ---

	const jsx_loading = null //<Loader />

	var jsx_recap = localError_jsx
	// we add each field one by one
	if (addressToBlacklist && addressToBlacklist.length > 0) {
		log("addressToBlacklist= ", addressToBlacklist)
		// const shorthash = shortTxHash(addressToBlacklist)
		// jsx_recap = <Fragment>
		// 		{jsx_recap}
		// 		{shorthash.length > 5?
		// 			<Fragment>
		// 				Blacklister {addressToBlacklist}
		// 				<br/><br/>
		// 			</Fragment>
		// 		:null}
		// 	</Fragment>
	}

	const jsx_sending =
		<Fragment>
			Blacklist en cours de {shortTxHash(addressToBlacklist)} &nbsp;
			<i className="reloadIcon fas fa-sync fa-spin" />
		</Fragment>


	const func_jsx_success = (txstate) => {
		return (
			<SuccessTxSender txstate={txstate}>
				Blacklist avec succès de {txstate.address}
			</SuccessTxSender>
		)
	}


	// --- HOOK useTxSender ---

	const [
		bool_broadcast_lock,
		func_resetMess,
		dict_sendbutton_style,
		jsx_mess,
	]
		= useTxSender(
			tokenActionID,
			array_bool_user_inputs,
			bool_context_has_loaded,
			ref_messageEndRef,
			mess_default,
			jsx_loading,
			jsx_recap,
			jsx_sending,
			func_jsx_success,
			default_func_jsx_fail,
			func_empty_fields,
		)


	// --- FUNCTIONS ---

	function handleChange_ValidAddress(new_addressToBlacklist) {
		if (bool_broadcast_lock) return // don't allow edit during sending
		func_resetMess()

		func_empty_fields()

		// var new_addressToBlacklist = event.target.value
		// new_addressToBlacklist = new_addressToBlacklist.replace(/ /g, "") // remove all spaces

		set_addressToBlacklist(new_addressToBlacklist)
	}

	function handleKeyDown(e) {
		if (e.key === 'Enter') {
			var fakeevent = document.createElement("div");
			fakeevent.preventDefault = function() { }
			handleClick(fakeevent)
		}
	}

	async function handleClick(event) {
		event.preventDefault() // prevent redirection
		if (bool_broadcast_lock) return // don't allow edit during sending

		const confirm_message = "Blacklister " + addressToBlacklist + " ?"
		var confirmed = await confirmPopup(confirm_message)
		if (!confirmed) return // abort

		userContext.blacklist_address(addressToBlacklist)
	}

	// --- DISPLAY ---

	log("\n addressToBlacklist = ", addressToBlacklist,
		"\n bool_broadcast_lock=", bool_broadcast_lock,)

	return (
		<div>
			<h1><i className="fas fa-ban" /><Spaces count="3" />
				Blacklister une adresse {tokenName}
			</h1>
			<br />

			{userContext.ownerIsAdmin ? null : <>
				<Alert variant="danger">
					<Bold>Vous ne semblez pas être l'administrateur de ce token.</Bold>
				</Alert><br />
			</>}

			<InputTokenAddress
				tokenName={tokenName}
				tokenID={tokenID}
				variant="token"
				value={addressToBlacklist}
				onValidChange={handleChange_ValidAddress}
				title={"Adresse " + tokenName + " à blacklister"}
			/>

			<center>
				<div ref={ref_messageEndRef}>
					{jsx_mess ?
						<Row>
							<TextDisplay>
								{jsx_mess}
							</TextDisplay>
						</Row>
						: null}
				</div>
			</center>

			<Row>
				<button style={dict_sendbutton_style} onClick={handleClick} className="submitbutton">
					Blacklister&nbsp;
					{addressToBlacklist ?
						<ShortTxHash txhash={addressToBlacklist} />
						: null}
				</button>
			</Row>
			<br /><br /><br /><br />

			<h1>
				<i className="fas fa-trash" /><Spaces count="3" />
				Adresses blacklistées
			</h1>
			<br />

			<BlacklistedAdressesTableau />
			<br />

		</div>
	)
}

const BlacklistedAdressesTableau = () => {

	const userContext = useContext(UserContext)
	const log = useLog("BlacklistedAdressesTableau: ")

	const has_loaded = (userContext.blacklist2d != null)
	log("has_loaded=", has_loaded, ", blacklist2d=", userContext.blacklist2d)

	var amount_jsx = ""
	if (has_loaded && userContext.blacklist2d) {
		const amount = userContext.blacklist2d.length
		if (amount >= 2) amount_jsx = amount + " adresses blacklistées"
		else amount_jsx = amount + " adresse blacklistée"
	}

	return (
		<Fragment>

			{has_loaded && userContext.blacklist2d && userContext.blacklist2d.length > 0 ?
				<Fragment>
					{amount_jsx}
					<br /><br />
				</Fragment>
				: null}

			<Tableau
				titles={["Date", "Adresse", "Action#"]}
				values={userContext.blacklist2d}
				loading={!has_loaded}
				empty_mess="Aucune adresse blacklistée pour le moment."
			/>

		</Fragment>
	)
}
